// src/utils/analytics.js

export const trackOutboundLink = (label) => {
    // Don't track in development
    if (process.env.NODE_ENV === 'development') {
        console.log('Development mode - would track:', label);
        return;
    }

    try {
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'click', {
                'event_category': 'outbound',
                'event_label': label,
                'transport_type': 'beacon'
            });
        } else {
            console.warn('gtag is not available');
        }
    } catch (error) {
        console.error('Error tracking outbound link:', error);
    }
};